import { GetServerSideProps } from 'next';
import { Params } from 'next/dist/server/router';
import { useRouter } from 'next/router';

import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import categoryAPI, { CATEGORY_END_POINT } from 'src/api/category';
import Seo from 'src/components/atoms/seo';
import CategoryCourses from 'src/components/templates/categoryCourses';
import Main from 'src/components/templates/main';
import { ICategory } from 'src/interfaces';
import { SWRConfig } from 'swr';

const SubCategories = ({ fallback }: any) => {
  const router = useRouter();
  const currentLanguage = router.locale;
  const subcategory: ICategory = fallback.SUBCATEGORY;
  const title = currentLanguage === 'th' ? subcategory.page_title : subcategory.page_title_en;
  return (
    <SWRConfig value={{ fallback }}>
      <Main coupon scrollToTop>
        <Seo title={title} description={subcategory.description} />
        <CategoryCourses isSubCategory />
      </Main>
    </SWRConfig>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { locale, params } = context as Params;

  const categorySlug = (params.slug as string) || '';
  const subCategorySlug = (params.subCategorySlug as string) || '';

  const [response] = await Promise.all([categoryAPI.fetchCategory(categorySlug, { includeDisabled: true })]);
  if (!response.data) {
    return {
      notFound: true,
    };
  }

  const category = response.data as ICategory;

  const subCategory = response.data.children.find(
    (item: ICategory) => item.slug.toLocaleLowerCase() === subCategorySlug.toLocaleLowerCase(),
  ) as ICategory;

  const [responseSections] = await Promise.all([categoryAPI.fetchSections(subCategory?.id)]);

  return {
    props: {
      ...(await serverSideTranslations(locale, ['common', 'store_cart'])),
      fallback: {
        [CATEGORY_END_POINT.SECTIONS(subCategory.id)]: responseSections.data ?? [],
        SUBCATEGORY: subCategory,
        CATEGORY: category,
      },
    },
  };
};

export default SubCategories;
